<template>
  <div id="upcoming">
    <div class="container">
      <img class="logo" :src="'~@/../img/logo.png'" />
    </div>
    <h1 class="title">{{ $t("miclive.home.upcoming") }}</h1>

    <div class="partners">
      <div class="title">{{ $t("miclive.home.partners") }}</div>
      <img
        class="sponsor"
        :src="sponsor"
        loading="lazy"
        height="300"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Upcoming",
  data() {
    return {};
  },
  computed: {
    sponsor() {
      var result = this.$store.getters["getSponsors"]("live");
      return result || false;
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.container {
  background: #182654;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 50px 0;
  .logo {
    max-width: 150px;
    margin: 0 auto;
    display: block;
  }
}
.title {
  text-align: center;
  margin: 100px 0;
  margin-top: 200px;
}

.partners {
  margin-top: 40px;
  text-align: center;
  .title {
    text-align: center;
    font-family: $font-text;
    margin: 0;
  }
  .logo {
    width: 100%;
    max-width: 500px;
  }
}
</style>
